import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';

import fancybox from 'fancybox';

import { slideNav } from '../../flux/functions';
// IMAGES
import logo_white from '../../assets/img/logo_white.svg';
import homextras from '../../assets/img/mundon.gif';
import iconmundon from '../../assets/img/icon-mundon.svg';
import homefeatured from '../../assets/img/home-featured.svg';
import enea from '../../assets/img/parceiro_enea.svg';
import fundoambiental from '../../assets/img/parceiro_fundoambiental.svg';
import biologos from '../../assets/img/parceiro-ordem-biologos.jpg';
import aspea from '../../assets/img/parceiro-aspea.jpg';

import Footer from '../footer/footer';

export default class Home extends Component {
	constructor(props){
		super(props);
	}
	componentWillReceiveProps(nextProps){
		if( this.props.location.key != nextProps.location.key ){
			$('body').css('margin-bottom', 352);
		}
	}
	componentDidMount(){
		$( '.content-container' ).on( 'mousewheel DOMMouseScroll', function ( e ) {
			var e0 = e.originalEvent,
				delta = e0.wheelDelta || -e0.detail;
		
			this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
			e.preventDefault();
		});
		slideNav( $('body') );
	}
	
	render(){
		return(
			<div>
				<main role="main" className="main-content">
				<div className="home">
					<nav className="vertical-nav hidden-md-down" id="vertical-nav">
						<a href="#home-header" className="nav__item" aria-label="home-header" data-number="1"></a>
						<a href="#home-featured" className="nav__item nav__item--current" aria-label="home-featured" data-number="2"></a>
						<a href="#home-extras" className="nav__item" aria-label="home-extras" data-number="3"></a>
					</nav>
					<section className="section-container home-header" id="home-header">
						<div className="home-header-video-container">
							<iframe id="ytplayer" width="560" height="315" src="https://www.youtube.com/embed/CiNLb8dtF6Y?rel=0&amp;controls=0&amp;showinfo=0&amp;mute=1&amp;autoplay=1&cc_load_policy=1" frameBorder="0" allowFullScreen></iframe>
						</div>
						<div className="container-fluid h-100">
							<div className="row justify-content-center align-items-center h-100">
								<div className="col-16 col-sm-14 col-lg-12 text-center">
									<div className="row mt-4">
										<div className="col">
											<img src={logo_white} alt="Mundo ON" />
										</div>
									</div>
									<div className="row mt-4">
										<div className="col">
											<h1>Todos queremos viver num mundo<br/>melhor e mais sustentável!</h1>
										</div>
									</div>
									<div className="row mt-4">
										<div className="col">
											<a className="btn btn-primary ver-video" href="https://www.youtube.com/watch?v=CiNLb8dtF6Y/?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1&cc_load_policy=1" allowfullscreen>Ver vídeo</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="section-container home-featured" id="home-featured">
						<div className="container-fluid h-100">
							<div className="row align-items-center h-100 relative">
								<div className="col-18 col-xs-16 offset-xs-2 col-lg-12 offset-lg-3 col-xl-6 offset-xl-2 relative ctn">
									<div className="content-container">
										<div className="content-body">
											<h2>O que é?</h2>
											<p className="excerpt">Todos queremos viver num mundo melhor e mais sustentável!</p>
											<p>O Mundo ON é o projeto que incentiva os jovens enquanto consumidores a adotar comportamentos de consumo mais sustentáveis, a reduzir os consumos, a efetuar escolhas mais responsáveis e fazer um uso mais eficiente dos recursos naturais.<br/><br/>As novas gerações são mais sensíveis aos desafios ambientais emergentes como as alterações climáticas, a sobre-exploração dos recursos, mas enquanto consumidores precisam ter maior consciência do impacte coletivo e ambiental dos seus atos individuais de consumo.</p>
											<div className="col-18 text-right">
												<a href="/iniciativa/mundon/o-que-e" className="btn btn-read-more">Ler mais</a>
											</div>
										</div>
									</div>
									<div className="question-mark">Queres viver<br/>num <span>mundo</span><br/>melhor?</div>
								</div>
								<div className="section-fixed">
									<div className="link-container">
										<img src={homefeatured} alt="Temas" />
										<a href="https://decojovem.pt/iniciativa/mundon/temas/compras" className="link-tema compras"></a>
										<a href="https://decojovem.pt/iniciativa/mundon/temas/residuos" className="link-tema residuos"></a>
										<a href="https://decojovem.pt/iniciativa/mundon/temas/mobilidade" className="link-tema mobilidade"></a>
										<a href="https://decojovem.pt/iniciativa/mundon/temas/energia" className="link-tema energia"></a>
										<a href="https://decojovem.pt/iniciativa/mundon/temas/agua" className="link-tema agua"></a>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="section-container home-extras" id="home-extras">
						<div className="container-fluid h-100">
							<div className="row align-items-center h-60 bg-residuos">
								<div className="col h-100 relative hidden-lg-down">
									<div className="animation">
										<img className="acoes-prof" src={homextras} alt="Ações de formação" />
										<img className="icon-mundon" src={iconmundon} alt="MundOn" />					
									</div>
								</div>
								<div className="col">
									<div className="row">
										<div className="col-18 col-sm-14 offset-sm-3 col-sm-12">
											<h2>Ações de formação sobre consumo sustentável</h2>
											<p className="mt-3">A DECO promoveu a capacitação dos professores em educação ambiental e do consumidor, através da realização de 6 ações de formação de curta duração, nos dias 18 e 25 de novembro de 2017, sobre o tema do consumo sustentável.<br/>Através destas ações foi possível apresentar o projeto Mundo ON, transmitir conteúdos informativos sobre consumo sustentável e apresentar os materiais didáticos criados para o desenvolvimento de atividades de educação ambiental e do consumidor em sala de aula.</p>
										</div>
									</div>
									<div className="row">
										<div className="col-18 offset-xs-10 offset-sm-11">
											<a className="btn btn-primary" href="https://decojovem.pt/consumo-sustentavel/professores-mais-ligados-ao-mundo/" role="button">Saber Mais</a>
										</div>
									</div>
								</div>
							</div>
							<div className="row align-items-center h-40">
								<div className="col-18 col-sm-14 offset-sm-3">
									<h3 className="h2">Apoio</h3>
									<ul className="list-partners mt-3">
										<li><a href="https://www.apambiente.pt/_zdata/DESTAQUES/2016/ENEA_final.pdf" target="_blank"><img src={enea} alt="ENEA" /></a></li>
										<li><a href="http://www.fundoambiental.pt/" target="_blank"><img src={fundoambiental} alt="Fundo Ambiental" /></a></li>
										<li><a href="http://ordembiologos.pt/" target="_blank"><img src={biologos} alt="Ordem dos Biólogos" /></a></li>
										<li><a href="https://aspea.org/" target="_blank"><img src={aspea} alt="ASPEA" /></a></li>
									</ul>
								</div>
							</div>
						</div>
					</section>
				</div>
				</main>
				<Footer />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/home/home.js